import React, { useState } from 'react';
import '../../assets/styles/onboard.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../../config';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Sendotp() {
    const [Email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const handleSendOtp = async (e) => {
        e.preventDefault();
        if (!Email) {
            alert('Please enter a valid Email ID or Mobile number.');
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post(`${config.apiBaseUrl}/admin/sendotpsmail`, { Email });
            if (!response.data.error) {
                toast.success(response.data.message);
                setTimeout(() => {
                    navigate('/verifyotp')
        
                }, 2000);
            } else {
                console.log(response.data.message || 'Failed to send OTP.');
            }
        } catch (err) {
            console.log(err.response?.data?.message || 'Failed to send OTP.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid ">
            <ToastContainer />
            <div className="row">
                <div className="onboard-container col-7"></div>
                <div className="col-5 logincontainediv">
                    <form className="logincontainer" onSubmit={handleSendOtp}>
                        <h2 className="signup-header">Forgot Password</h2>
                        <div className="mb-3">
                            <label htmlFor="username" className="form-label">
                                Enter your Email
                            </label>
                            <input
                                type="email"
                                className="form-style-cls"
                                id="email"
                                name="email"
                                placeholder="Enter Email..."
                                value={Email}
                                maxLength={50}
                                required
                                onChange={(e) => setEmail(e.target.value)} 
                            />
                        </div>

                      

                        <button
                            type="submit"
                            className="btn btn-primary signup-btn"
                            disabled={loading}
                        >
                            {loading ? 'Sending...' : 'Send OTP'}
                        </button>
                        <div className="footer-signup">
                            <h5 className="signfoot-header">Back to</h5>
                            <button className="btn-link" type="button" onClick={() => navigate('/')}>
                                Login
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Sendotp;
